"use client";

import React from "react";
import { Maximize2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTrigger, DialogTitle } from "@/components/ui/dialog";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryImages = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620541/img/gallery_bchoops_shooting.png",
  alt: "Bryan Christiansen demonstrating professional shooting form with focused precision"
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620541/img/gallery_bchoops_dribbling.png",
  alt: "High-intensity elite ball handling and crossover drills"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620541/img/gallery_bchoops_vertical.png",
  alt: "Explosive vertical jump and plyometric training for peak performance"
}, {
  id: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620541/img/gallery_bchoops_defense.png",
  alt: "Lockdown defensive footwork and lateral quickness session"
}, {
  id: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620541/img/gallery_bchoops_coaching.png",
  alt: "One-on-one professional coaching and strategic breakdown"
}, {
  id: 6,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620541/img/gallery_bchoops_conditioning.png",
  alt: "Pro-level basketball conditioning and high-octane agility training"
}, {
  id: 7,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620541/img/gallery_bchoops_weights.png",
  alt: "Functional strength training specifically designed for basketball players"
}, {
  id: 8,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620541/img/gallery_bchoops_youth.png",
  alt: "Youth development program building fundamental basketball excellence"
}, {
  id: 9,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620541/img/gallery_bchoops_scrimmage.png",
  alt: "Competitive training scrimmage under professional game-like conditions"
}];
export default function IronAndSweatGallery() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const galleryReveal = useRevealOnScroll({
    threshold: 0.05
  });
  const buttonReveal = useRevealOnScroll({
    threshold: 0.5
  });
  return <section data-section-id="82773" id="training-action" className="dark bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerReveal.ref} className={`text-center mb-16 transition-all duration-1000 ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-4xl md:text-6xl font-serif tracking-tighter uppercase text-foreground mb-4">
            TRAINING <span className="text-primary">ACTION</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-sans">
            Witness the elite performance mastery at BCHOOPS. Experience the high-octane environment where Bryan Christiansen translates 8 years of pro ball expertise into your game.
          </p>
        </div>

        {}
        <div ref={galleryReveal.ref} className={`columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4 transition-all duration-1000 delay-200 ${galleryReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {galleryImages.map((image, index) => <div key={image.id} data-index={index} className="break-inside-avoid">
              <Dialog>
                <DialogTrigger asChild>
                  <div className="relative group cursor-pointer overflow-hidden bg-card border border-white/10 rounded-sm">
                    <img src={image.src} alt={image.alt} className="w-full h-auto object-cover grayscale transition-all duration-700 ease-in-out group-hover:grayscale-0 group-hover:scale-110" loading="lazy" />
                    {}
                    <div className="absolute inset-0 bg-background/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center">
                      <div className="bg-primary/90 p-3 rounded-sm backdrop-blur-sm border border-primary text-primary-foreground shadow-[0_0_20px_rgba(255,102,0,0.4)] transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                        <Maximize2 className="w-6 h-6" />
                      </div>
                    </div>
                  </div>
                </DialogTrigger>
                <DialogContent className="max-w-[95vw] sm:max-w-[90vw] md:max-w-[80vw] lg:max-w-[1200px] h-[90vh] p-1 border-white/10 bg-background/95 backdrop-blur-xl flex flex-col items-center justify-center shadow-2xl">
                  <DialogTitle className="sr-only">{image.alt}</DialogTitle>
                  <div className="relative w-full h-full flex items-center justify-center p-4">
                    <img src={image.src} alt={image.alt} className="max-w-full max-h-full object-contain shadow-2xl border border-white/5" />
                  </div>
                </DialogContent>
              </Dialog>
            </div>)}
        </div>

        {}
        <div ref={buttonReveal.ref} className={`mt-16 flex justify-center transition-all duration-1000 delay-400 ${buttonReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          
        </div>
      </div>
    </section>;
}